import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendListModel } from 'src/app/models/common/list.model';
import { DomainCode } from 'src/app/models/common/model';
import { LeaseAgreement, LeaseAgreementClass, RequestDetailModel } from 'src/app/models/request-detail-model';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';
import { LeaseQuoteTableService } from '../quoteTable/lease-quote-table/lease-quote-table.service';
import { LeaseQuoteTableComponent } from '../quoteTable/lease-quote-table/lease-quote-table.component';

@Component({
  selector: 'logzy-info-content',
  templateUrl: './info-content.component.html',
  styleUrls: ['./info-content.component.scss']
})
export class InfoContentComponent implements OnInit {
  @Input() loader: boolean = true;
  @Input() requestDetails: RequestDetailModel;

  @Output() editLR = new EventEmitter<any>();

  @Input()
  isEditable: boolean = true;

  locationSourceLabel: string;
  locationDestinationLabel: string;

  lessorCompany: string = '';
  lessorAddress: string = '';
  lessorContactDetails: string = '';

  lesseeCompany: string = '';
  lesseeAddress: string = '';
  lesseeContactDetails: string = '';
  leaseAgreementDuration: string = '';
  errorObj: any = {};
  dd_leaseUse: BackendListModel<DomainCode>;
  currencyMaster_url = ApiRoutes.CurrencyMaster;
  dd_leaseOptions: any;
  leaseDetailsExpand: boolean = false;
  defaultCurrency: string = '';

  constructor(public requestService: RequestApiService, private _snackBar: MatSnackBar, private domainService: DomainCodeApiService,
    private dialog: MatDialog,
    public leaseQuoteService: LeaseQuoteTableService) { }

  ngOnInit() {
    console.log("this.requestDetails.lease_agreement", this.requestDetails.lease_agreement);
    this.getAllData();
    this.getLeaseUse();
    this.leaseAgreementOptions(this.requestDetails.id);
    this.requestService.selectedAgreementDetails = this.requestDetails.lease_agreement;
  }

  getAllData() {
    if (this.requestDetails.lease_agreement != null) {
      if (this.requestDetails?.lease_agreement.lease_type != null) {
        switch (this.requestDetails.lease_agreement.lease_type) {
          case 'operational_lease': {
            this.requestDetails.lease_agreement.lease_type = 'Operational Lease';
            break;
          }
          case 'financial_lease': {
            this.requestDetails.lease_agreement.lease_type = 'Financial Lease';
            break;
          }
          default:
            break;
        }
      }
      if (this.requestDetails?.lease_agreement.billing_cycle != null) {
        switch (this.requestDetails.lease_agreement.billing_cycle) {
          case 'yearly': {
            this.requestDetails.lease_agreement.billing_cycle = 'Yearly';
            break;
          }
          case 'quarterly': {
            this.requestDetails.lease_agreement.billing_cycle = 'Quarterly';
            break;
          }
          case 'monthly': {
            this.requestDetails.lease_agreement.billing_cycle = 'Monthly';
            break;
          } case 'half_yearly': {
            this.requestDetails.lease_agreement.billing_cycle = 'Half Yearly';
            break;
          }
          default:
            break;
        }
      }
      if (this.requestDetails?.lease_agreement.billing_date != null) {
        switch (this.requestDetails?.lease_agreement.billing_date.toString()) {
          case '1': {
            this.requestDetails.lease_agreement.billing_date = '1st of every month';
            break;
          }
          case '5': {
            this.requestDetails.lease_agreement.billing_date = '5th of every month';
            break;
          }
          case '7': {
            this.requestDetails.lease_agreement.billing_date = '7th of every month';
            break;
          }
          case '10': {
            this.requestDetails.lease_agreement.billing_date = '10th of every month';
            break;
          }
          default:
            break;
        }
      }

      if (this.requestDetails.lease_agreement.agreement_ends_on !== null && this.requestDetails.lease_agreement.agreement_starts_from != null) {
        const date1: Date = new Date(this.requestDetails.lease_agreement.agreement_ends_on);
        const date2: Date = new Date(this.requestDetails.lease_agreement.agreement_starts_from);

        const timeDifferenceMs: number = date1.getTime() - date2.getTime();
        const differenceInDays: number = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));

        this.leaseAgreementDuration = differenceInDays + ' Days';
        // console.log("this.leaseAgreementDuration", this.leaseAgreementDuration);

      }


      if (this.requestDetails.lease_agreement.currency == null)
        this.requestDetails.lease_agreement.currency = 'USD';

      console.log('this.requestDetails.lease_agreement.currency', this.requestDetails.lease_agreement.currency);
      this.defaultCurrency = this.requestDetails.lease_agreement.currency;
      console.log('this.defaultCurrency', this.defaultCurrency);

    }
  }
  getLeaseUse() {
    this.domainService.getByGroup('ContainerPurpose').subscribe(response => {
      this.dd_leaseUse = response;
    })
  }

  calculateLeaseAgreementDuration(event) {
    if (event != null) {
      let end_date = new Date(event);
      let leasingPeriodDays = null;
      leasingPeriodDays = this.leaseQuoteService.baseQuote?.quote_items.reduce((max, item) => (item.leasing_period_days > max ? item.leasing_period_days : max), this.leaseQuoteService.baseQuote?.quote_items[0].leasing_period_days);
      end_date.setDate(end_date.getDate() + leasingPeriodDays);
      this.requestDetails.lease_agreement.agreement_ends_on = end_date;

    }

    if (this.requestDetails?.lease_agreement.agreement_ends_on <= this.requestDetails?.lease_agreement.agreement_starts_from) {
      this.requestDetails.lease_agreement.agreement_ends_on = null;
      return;
    }

    if (this.requestDetails?.lease_agreement.agreement_ends_on !== null && this.requestDetails?.lease_agreement.agreement_starts_from != null) {
      const date1: Date = new Date(this.requestDetails?.lease_agreement.agreement_ends_on);
      const date2: Date = new Date(this.requestDetails?.lease_agreement.agreement_starts_from);
      const timeDifferenceMs: number = date1.getTime() - date2.getTime();
      const differenceInDays: number = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));
      this.leaseAgreementDuration = differenceInDays + ' Days';
    }
  }

  calculateLeaseAgreementDurationEndDate() {
    if (this.requestDetails?.lease_agreement.agreement_ends_on <= this.requestDetails?.lease_agreement.agreement_starts_from) {
      this.requestDetails.lease_agreement.agreement_ends_on = null;
      return;
    }

    if (this.requestDetails?.lease_agreement.agreement_ends_on !== null && this.requestDetails?.lease_agreement.agreement_starts_from != null) {
      const date1: Date = new Date(this.requestDetails?.lease_agreement.agreement_ends_on);
      const date2: Date = new Date(this.requestDetails?.lease_agreement.agreement_starts_from);
      const timeDifferenceMs: number = date1.getTime() - date2.getTime();
      const differenceInDays: number = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));
      this.leaseAgreementDuration = differenceInDays + ' Days';
    }
  }

  leaseAgreementOptions(reqId) {
    this.requestService.optionsLeaseAgreement(this.requestDetails.id).subscribe(response => {
      this.dd_leaseOptions = response;
    })
  }

  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      return error;
    }
  }

  openWarning(label: string, description, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
    });
  }

  setDefaultCurrency(event) {
    console.log('setDefaultCurrency', event, this.defaultCurrency);
    if (event.currency_code != this.defaultCurrency)
      this.openConfirm(event, 'You are about to change the currency of all quotes.', 'Are you sure you want to continue?', 'Abort', 'Proceed');
  }

  openConfirm(newCurrency, label: string, temp, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: temp, label1: action1, label2: action2 }
    });

    dialogRef.afterClosed().subscribe((is_positive) => {
      if (is_positive == false || is_positive == undefined) {
        this.requestDetails.lease_agreement.currency = this.defaultCurrency;
        this.leaseQuoteService.baseQuote.quote_items.map(quote => {
          quote.per_diem_charge_currency = this.defaultCurrency;
          quote.post_build_down_per_diem_charge_currency = this.defaultCurrency;
          quote.drv_new_build_price_currency = this.defaultCurrency;
        });
      } else {
        this.leaseQuoteService.baseQuote.quote_items.map(quote => {
          quote.per_diem_charge_currency = newCurrency.currency_code;
          quote.post_build_down_per_diem_charge_currency = newCurrency.currency_code;
          quote.drv_new_build_price_currency = newCurrency.currency_code;
        });
      }
    });
  }
}
